import { BASE_URL, HTTP_METHODS } from "../App/Configs/AppConfigs";
import ApiHelper from "../App/Utils/ApiHelper";
import { SUPPLIER_FEEDBACK_BASE_API_PATH } from "./Constants";

export class DataProvider {
  apiHelper = new ApiHelper(BASE_URL + SUPPLIER_FEEDBACK_BASE_API_PATH);
  masterApiHelper = new ApiHelper(BASE_URL + "/master");

  getDropdownValues = async (model) => {
    return await this.masterApiHelper.apiCall('/masters.'+model+"/list?is_active=True&filter=1&page=1&pageSize=100000", HTTP_METHODS.GET, null);
  };

  getDependentDropdownValues = async (model, filter) => {
    return await this.masterApiHelper.apiCall('/masters.'+model+"/list?is_active=True&page=1&pageSize=100000&filter=1&"+filter, HTTP_METHODS.GET, null);
  };

  requestFeedback = async (payload) => {
    return await this.apiHelper.apiCall('/', HTTP_METHODS.POST, payload);
  };

  submitFeedback = async (feedbackId, payload) => {
    return await this.apiHelper.apiCall('/'+ feedbackId, HTTP_METHODS.PUT, payload);
  };

  updateFeedback = async (feedbackId, payload) => {
    return await this.apiHelper.apiCall('/'+ feedbackId, HTTP_METHODS.PATCH, payload);
  };

  getFeedback = async (value) => {
    return await this.apiHelper.apiCall('/'+value, HTTP_METHODS.GET, null);
  };

  getPrevFeedback = async (values) => {
    return await this.apiHelper.apiCall('/' + values, HTTP_METHODS.GET, null);
  };

  getFeedbackScoreCard = async (values) => {
    return await this.apiHelper.apiCall('/score-card/', HTTP_METHODS.POST, values);
  };

  getMonthlyFeedbackReport = async () => {
    return await this.apiHelper.apiCall('/monthly-report', HTTP_METHODS.GET, null);
  };

  getQuarterlyFeedbackReport = async (values) => {
    return await this.apiHelper.apiCall('/quarterly-report/', HTTP_METHODS.POST, values);
  };
}
